/**
 * 密码哈希与验证工具
 * 使用 crypto-js SHA256 + 随机盐
 */
import CryptoJS from 'crypto-js'

/**
 * 生成随机盐值
 * @param {number} length - 盐值长度，默认 16
 * @returns {string} 随机盐值
 */
export function generateSalt(length = 16) {
  const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
  let salt = ''
  for (let i = 0; i < length; i++) {
    salt += chars.charAt(Math.floor(Math.random() * chars.length))
  }
  return salt
}

/**
 * 对密码进行 SHA256 哈希（加盐）
 * @param {string} password - 明文密码
 * @param {string} salt - 盐值
 * @returns {string} 哈希后的密码
 */
export function hashPassword(password, salt) {
  if (!password || !salt) return ''
  return CryptoJS.SHA256(password + salt).toString()
}

/**
 * 验证密码
 * @param {string} password - 用户输入的明文密码
 * @param {string} hash - 存储的哈希值
 * @param {string} salt - 存储的盐值
 * @returns {boolean} 是否匹配
 */
export function verifyPassword(password, hash, salt) {
  if (!password || !hash || !salt) return false
  return hashPassword(password, salt) === hash
}
